export default __webpack_public_path__ + "static/media/vespistiLogo.afe23f23.svg";